(ns portal.os-access-modal.db
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.url-template :as url-tpl]
            [phrase.alpha :as p]
            [re-frame.core :as rf]))

(def initial-value
  {:purpose ""
   :notes ""

   :agency ""
   :advertiser ""

   :pitch-material ""
   :campaign-link ""})

(def purpose #{"demo" "enable-advertiser" "pitch"})
(def pitch-material #{"sample" "existing" "custom"})

(defn campaign-link? [value]
  (boolean (re-matches #"^(https://)?(?:[a-zA-Z0-9-]+\.)*create\.choreograph\.com/manage/\d+/advertiser/\d+/campaign/\d+$" value)))

(spec/def ::purpose (spec/nilable purpose))
(spec/def ::notes (spec/and string? (complement str/blank?)))
(spec/def ::agency (spec/and string? (complement str/blank?)))
(spec/def ::advertiser (spec/and string? (complement str/blank?)))
(spec/def ::pitch-material pitch-material)
(spec/def ::campaign-link campaign-link?)

;; Pitch specific specs
(defmulti pitch :pitch-material)

(defmethod pitch "existing" [_]
  (spec/keys :req-un [::purpose
                      ::pitch-material
                      ::campaign-link]))

(defmethod pitch :default [_]
  (spec/keys :req-un [::purpose
                      ::pitch-material]))

;; Form specs
(defmulti value :purpose)

(defmethod value "pitch" [_]
  (spec/multi-spec pitch :pitch-material))

(defmethod value "demo" [_]
  (spec/keys :req-un [::purpose]))

(defmethod value "enable-advertiser" [_]
  (spec/keys :req-un [::purpose
                      ::agency
                      ::advertiser]))

(defmethod value :default [_]
  (spec/keys :req-un [::notes]
             :opt-un [::purpose]))

(spec/def ::value
  (spec/multi-spec value :purpose))

(p/defphraser purpose
  [_ problem]
  {:message "Please select the purpose of your request"
   :in (:in problem)
   :problem problem})

(p/defphraser pitch-material
  [_ problem]
  {:message "Please select the material that you want to use for your pitch"
   :in (:in problem)
   :problem problem})

(p/defphraser campaign-link?
  [_ problem]
  {:message "Please enter a valid campaign link"
   :in (:in problem)
   :problem problem})

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.os-access-modal ::value)))

(rf/reg-event-fx ::request-success
  (fn [_ _]
    {:fx [[:dispatch [:modal/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name "Request"
                       :type :success
                       :message "Succesfully submitted"}]]]}))

(rf/reg-event-fx ::request-failure
  (fn [_ _]
    {:fx [[:dispatch [:modal/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name "Request"
                       :type :error
                       :message "Failed to send request, please contact support"}]]]}))

(rf/reg-event-fx ::submit-form
  [validate-form
   (rf/inject-cofx :sub :url-context)
   (rf/inject-cofx :sub :common.os/context)]
  (fn [{:common.os/keys [context]
        :keys [_ url-context]} [_ payload]]
    {:fx [[:http
           {:method :post
            :uri (url-tpl/render :api/os-workspace-mapping-request url-context)
            :params (-> payload
                        (->> (remove (fn [[_ v]]
                                       (or (nil? v)
                                           (and (string? v) (str/blank? v)))))
                             (into {}))
                        (assoc :context context))
            :on-success [::request-success]
            :on-failure [::request-failure]}]]}))

(def use-error-message (partial form/use-error-message :form.os-access-modal))

(def use-bind-control (partial form/use-bind-control :form.os-access-modal))

(form/register-form {:namespace :form.os-access-modal
                     :initial-value initial-value
                     :validate-form validate-form
                     :submit-event ::submit-form})
